import { useState } from 'react'
import { Tooltip } from 'antd';
import copy from 'clipboard-copy';
import CopyIcon from '../../assets/CopyIcon';
import CopySuccess from '../../assets/CopySuccess';

const Copy = ({ text, children }) => {
    const [isCopy, setIsCopy] = useState(false)

    const copyText = () => {
        setIsCopy(true)
        copy(text)
        setTimeout(() => setIsCopy(false), 1500)
    }
    return (
        <>
            {children ?
                <div className='flex items-center mt-3' onClick={copyText}>
                    {isCopy ?
                        <div className='border border-green-700 text-green-700 rounded-md flex items-center justify-center gap-3 px-4 py-2'>
                            <span>Copied</span>
                            <CopySuccess />
                        </div> : children}
                </div> :
                isCopy ?
                    <div>
                        <Tooltip title="Copied" open>
                            <CopySuccess />
                        </Tooltip>
                    </div> :
                    <div onClick={copyText} className='cursor-pointer size-5 flex justify-center items-center'>
                        <CopyIcon />
                    </div>
            }
        </>
    )
}

export default Copy